import * as React from 'react';
import { Body1AccentedTypography, Email } from '@components/atoms';
import { MailToLink, ShortDetailLayout } from '@components/molecules';
import { cn } from '@utils';

interface IEmailButtonProps {
	email: string;
	className?: string;
}

/**
 * Renders an email address as a clickable mailto link with an envelope icon.
 * @param email - The email address to display and link to.
 * @param className - Optional Tailwind classes to override the default width constraint (e.g. "max-w-none" to disable ellipsis).
 */
const EmailButton = ({ email, className }: IEmailButtonProps) => {
	return (
		<ShortDetailLayout icon={<Email className="shrink-0" />} data-testid="email-button">
			<MailToLink className="text-primary" link={email}>
				<Body1AccentedTypography className={cn('max-w-80 text-primary md:w-120', className)}>
					{email}
				</Body1AccentedTypography>
			</MailToLink>
		</ShortDetailLayout>
	);
};

export { EmailButton };
